'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRN;
/*
 * @Author: edvardchen
 * @Date: 2018-01-22 16:20:30
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-09-23 12:04:54
 */

/**
 * 是否在React-Native内
 */
/* global window */
function isRN() {
  return !!(typeof window !== 'undefined' && (window.originalPostMessage || window.__REACT_WEB_VIEW_BRIDGE && window.__REACT_WEB_VIEW_BRIDGE.postMessage));
}